import { render, staticRenderFns } from "./ProductIndex.vue?vue&type=template&id=90194622&scoped=true"
import script from "./ProductIndex.vue?vue&type=script&lang=js"
export * from "./ProductIndex.vue?vue&type=script&lang=js"
import style0 from "./ProductIndex.vue?vue&type=style&index=0&id=90194622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90194622",
  null
  
)

export default component.exports